import Vue from 'vue'
import App from './layouts/App'
import { createStore } from './store/index'
import { createRouter } from './router/index'
import vuetify from './vuetify'
import './plugins/components'

export function createApp (ctx = false) {
  const router = createRouter()
  const store = createStore()
  const app = new Vue({
    router,
    store,
    vuetify,
    ...App,
    mounted () {
      if(!ctx) {
        this.$client.channel('bus').listen('BroadcastEvent', (e) => {
          this.$root.$emit(e.action, e.param)
        })
        
        this.$client.private.prefix('bus').listen('PrivateEvent', (e) => {
          this.$root.$emit(e.action, e.param)
          this.$root.$emit('dot.action')
        })
      }
    },
    methods: {

    }
  })
  return { app, router, store }
}




// WEBPACK FOOTER //
// ./src/app.js